if (!customElements.get('product-card')) {
  class ProductCard extends HTMLElement {
    constructor() {
      super();
      this.debounceTimeout = null;
    }

    get sizesEl() {
      return this.querySelector('[data-swatches-and-sizes] .size-options');
    }

    connectedCallback() {
      if (this.sizesEl) {
        this.displaySizes();

        // Set up ResizeObserver with a debounced callback
        let resizeObserver = new ResizeObserver(() => this.debounce(this.displaySizes.bind(this), 100));
        resizeObserver.observe(this.sizesEl);
      }
    }

    disconnectedCallback() {
      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
      }
    }

    debounce(func, delay) {
      clearTimeout(this.debounceTimeout);
      this.debounceTimeout = setTimeout(func, delay);
    }

    displaySizes() {
      const children = Array.from(this.sizesEl.children).filter((child) => !child.classList.contains('more-sizes'));
      const plusIcon = this.sizesEl.querySelector('.more-sizes');

      // Reset visibility on all children initially
      children.forEach((child) => child.classList.remove('hidden'));

      // Get the flex gap value
      const gap = parseFloat(window.getComputedStyle(this.sizesEl).gap) || 0;
      const paddingLeft = parseFloat(window.getComputedStyle(this.sizesEl).paddingLeft) || 0;

      let totalWidth = paddingLeft + 8;
      const containerWidth = this.sizesEl.clientWidth;
      let overflow = false;

      // Loop through child elements to calculate cumulative width
      children.forEach((child, index) => {
        const childWidth = child.offsetWidth;
        totalWidth += childWidth;

        if (index < children.length - 1) {
          totalWidth += gap;
        }

        if (totalWidth > containerWidth) {
          overflow = true;
          child.classList.add('hidden');
        } else {
          child.classList.remove('hidden');
        }
      });

      // Show or hide the `+` icon based on whether there is overflow
      if (plusIcon) {
        plusIcon.classList.toggle('hidden', !overflow);
      }
    }
  }

  customElements.define('product-card', ProductCard);
}
